import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { Link } from "react-router-dom";
import Popover from "@mui/material/Popover";
import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { connect } from "react-redux";
import { getWrappedEmailAddress } from "../../../utils/profile";
import { styled } from "@mui/material/styles";
import useNavigateQSA from "../../../utils/hooks/useNavigateQSA";
import { useTheme } from "@mui/material";
import {
	format,
	generateId,
	isArrayOfLength,
	isObject,
	isStringOfLength
} from "@pheaa/channels-component-library";

const IconEdit = props => {
	return (
		<SvgIcon fill="none" sx={{ height: "19px", width: "19px" }} viewBox="0 0 19 19">
			<path d="M1 4.74897L11.9988 15.6768L18 18L15.7119 11.9777L4.72314 1L1 4.74897Z" fill="#265DDA" />
			<path d="M11.9988 15.6768L15.722 11.9777M11.9988 15.6768L1 4.74897L4.72314 1L15.7119 11.9777L18 18L11.9988 15.6768Z" fill="#265DDA" stroke="white" strokeLinejoin="round" />
		</SvgIcon>
	);
};

const IconInfo = props => {
	return (
		<SvgIcon fill="none" sx={{ height: "19px", width: "19px" }} viewBox="0 0 19 19">
			<path d="M9.5 18C14.1944 18 18 14.1944 18 9.5C18 4.80558 14.1944 1 9.5 1C4.80558 1 1 4.80558 1 9.5C1 14.1944 4.80558 18 9.5 18Z" fill="transparent" stroke="#265DDA" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M8.4375 14.1724H10.7963H10.8033C11.1628 14.1724 11.4596 13.8756 11.4596 13.5162C11.4596 13.1567 11.1628 12.8599 10.8033 12.8599H10.2767V7.02075C10.2767 6.6613 9.97987 6.3645 9.62042 6.3645H8.4375C8.07805 6.3645 7.78125 6.6613 7.78125 7.02075C7.78125 7.3802 8.07805 7.677 8.4375 7.677H8.96417V12.8599H8.4375C8.07805 12.8599 7.78125 13.1567 7.78125 13.5162C7.78125 13.8756 8.07805 14.1724 8.4375 14.1724Z" fill="#265DDA" stroke="#265DDA" strokeWidth="0.25" />
			<path d="M9.6001 5.5C10.1524 5.5 10.6001 5.05228 10.6001 4.5C10.6001 3.94772 10.1524 3.5 9.6001 3.5C9.04781 3.5 8.6001 3.94772 8.6001 4.5C8.6001 5.05228 9.04781 5.5 9.6001 5.5Z" fill="#265DDA" />
		</SvgIcon>
	);
};

const InfoPopover = ({ children, id = generateId(), label = "More Information", ...props }) => {

	const [anchorEl, setAnchorEl] = React.useState(null);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);

	return (
		<React.Fragment>
			<IconButton onClick={handleClick}>
				<IconInfo /><span className="a11y-hidden">{label}</span>
			</IconButton>
			<Popover
				anchorEl={anchorEl}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				id={id}
				onClose={handleClose}
				open={open}
				slotProps={{ paper: { sx: { overflow: "visible" } } }}
				transformOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
			>
				<Box sx={{
					position: "relative",
					"&::before": {
						border: "6px solid transparent",
						borderBottom: "6px solid white",
						content: "\"\"",
						display: "block",
						position: "absolute",
						right: 12,
						top: -12,
						width: 12
					}
				}} />
				<Box sx={{
					fontSize: 12,
					padding: 2,
					paddingRight: 4,
					position: "relative"
				}}>
					<IconButton
						color="primary"
						onClick={handleClose}
						sx={{
							position: "absolute",
							right: 0,
							top: 0
						}}
					>
						<CloseIcon fontSize="small" />
						<span className="a11y-hidden">Close Details</span>
					</IconButton>
					{children}
				</Box>
			</Popover>
		</React.Fragment >
	);
};

const UnavailableInfo = styled(Box)(({ theme }) => ({
	fontStyle: "italic",
	fontWeight: 300
}));

export const InvalidInfo = ({ sx, ...props }) => {

	const { text = "Invalid" } = props;
	const theme = useTheme();

	return (
		<Box
			alignItems="center"
			color={theme.palette.error.main}
			fontSize={12}
			fontWeight={300}
			ml={1}
			sx={{
				background: `url(${process.env.PUBLIC_URL}/assets/general/icon-alert.svg) no-repeat left center / 17px 17px`,
				display: "flex",
				paddingLeft: 2.75,
				paddingTop: 0.25,
				...sx
			}}
		>
			{text}
		</Box>
	);
};

const ContactInfoList = props => {

	let contactEmailActionElem = null;
	let contactEmailElem = null;
	let contactEmailInvalidElem = null;
	let iamEmailActionElem = null;
	let iamEmailElem = null;
	let iamPhoneActionElem = null;
	let iamPhoneElem = null;
	let legalNameActionElem = null;
	let legalNameElem = null;
	let legalAddressActionElem = null;
	let legalAddressElem = null;
	let legalAddressInvalidElem = null;
	let primaryPhoneActionElem = null;
	let primaryPhoneElem = null;
	let primaryPhoneInvalidElem = null;

	const {
		includeActions = false,
		profileData
	} = props;

	const navigate = useNavigateQSA();

	if (isObject(profileData)) {

		if (isObject(profileData.demographics) && isObject(profileData.demographics.name)) {
			legalNameElem = format.asProperName(profileData.demographics.name);
		}

		if (isObject(profileData.contacts)) {

			if (isArrayOfLength(profileData.contacts.addresses)) {
				let legalAddressObj = profileData.contacts.addresses.find(addrObj => addrObj.id === "legal");

				if (isObject(legalAddressObj)) {
					let isForeign = legalAddressObj.countryCode !== "US";

					if (isForeign) {
						!legalAddressObj.isValid && (legalAddressInvalidElem = <InvalidInfo text="Invalid Address" />);
						legalAddressElem = (
							<div>{format.asAddress(legalAddressObj)}</div>
						);
					} else {
						const { line1, line2, line3, cityStateZip } = format.asProperAddressObj(legalAddressObj);
						!legalAddressObj.isValid && (legalAddressInvalidElem = <InvalidInfo text="Invalid Address" />);
						legalAddressElem = (
							<div>
								{
									[line1, line2, line3, cityStateZip].filter(x => x !== null).map((text, i) => {
										return (
											<React.Fragment key={i}>
												{i > 0 ? <br /> : null} {text}
											</React.Fragment>
										);
									})
								}
							</div>
						);
					}
				} else {
					legalAddressElem = <UnavailableInfo>No legal address on record.</UnavailableInfo>;
				}
			}

			if (isArrayOfLength(profileData.contacts.emails)) {
				let contactEmailObj = profileData.contacts.emails.find(emailObj => emailObj.id === "contact");

				if (isObject(contactEmailObj) && isStringOfLength(contactEmailObj.email)) {
					contactEmailElem = getWrappedEmailAddress(contactEmailObj.email);
				} else {
					contactEmailElem = <UnavailableInfo>No contact email on record.</UnavailableInfo>;
				}

				isObject(contactEmailObj) && !contactEmailObj.isValid && (contactEmailInvalidElem = <InvalidInfo text="Invalid Email" />);
			}

			if (isArrayOfLength(profileData.contacts.phones)) {
				let primaryPhoneObj = profileData.contacts.phones.find(phoneObj => phoneObj.id === "primary");

				if (isObject(primaryPhoneObj)) {
					let isForeign = primaryPhoneObj.countryCode !== "1";
					primaryPhoneElem = format.asPhone(primaryPhoneObj.number, {
						countryCode: isForeign ? primaryPhoneObj.countryCode : null,
						isForeign,
						outputPattern: isForeign ? "###-####" : "###-###-####"
					});
				} else {
					primaryPhoneElem = <UnavailableInfo>No contact phone number on record.</UnavailableInfo>;
				}

				isObject(primaryPhoneObj) && !primaryPhoneObj.isValid && (primaryPhoneInvalidElem = <InvalidInfo text="Invalid Phone" />);
			}
		}

		if (isObject(profileData.iam)) {

			if (isStringOfLength(profileData.iam.email)) {
				iamEmailElem = getWrappedEmailAddress(profileData.iam.email);
			}

			if (isStringOfLength(profileData.iam.phone)) {
				iamPhoneElem = (profileData.iam.phone.startsWith("+1") && profileData.iam.phone.length === 12) ? format.asPhone(profileData.iam.phone.substring(2), {
					outputPattern: "###-###-####"
				}) : profileData.iam.phone;
			}
		}

		if (includeActions) {

			legalNameActionElem = (
				<InfoPopover>
					To change your legal name, contact <Link to="?help=phone">customer support</Link>.
				</InfoPopover>
			);

			legalAddressActionElem = (
				<IconButton onClick={() => { navigate("/profile/edit-address"); }}>
					<IconEdit /><span className="a11y-hidden">Edit Legal Address</span>
				</IconButton>
			);

			contactEmailActionElem = (
				<IconButton onClick={() => { navigate("/profile/edit-contact-email"); }}>
					<IconEdit /><span className="a11y-hidden">Edit Contact Email</span>
				</IconButton>
			);

			iamEmailActionElem = (
				<InfoPopover>
					To change your sign in email, contact <Link to="?help=phone">customer support</Link>.
				</InfoPopover>
			);

			primaryPhoneActionElem = (
				<IconButton onClick={() => { navigate("/profile/edit-contact-phone"); }}>
					<IconEdit /><span className="a11y-hidden">Edit Contact Phone</span>
				</IconButton>
			);

			iamPhoneActionElem = (
				<InfoPopover>
					To change your sign in phone, contact <Link to="?help=phone">customer support</Link>.
				</InfoPopover>
			);

		}
	}

	const GridRow = styled(Box)(({ theme }) => ({
		alignItems: "center",
		borderBottom: `1px solid ${theme.palette.neutral.main}`,
		columnGap: 8,
		display: "grid",
		gridTemplateColumns: "max-content 1fr min-content",
		minHeight: 80,
		paddingBottom: "0.4rem",
		paddingTop: "0.4rem",
		":last-of-type": {
			borderBottom: `1px solid ${theme.palette.neutral.main}`
		}
	}));

	const GridRowItem = styled(Box)(({ theme }) => ({}));

	const GridRowItemLabel = styled(Box)(({ theme }) => ({}));

	const GridRowItemDetails = styled(Box)(({ theme }) => ({
		display: "flex",
		flexWrap: "wrap-reverse",
		fontWeight: 700,
		justifyContent: "flex-end",
		textAlign: "right",
		wordBreak: "break-all"
	}));

	return (
		<React.Fragment>
			<GridRow>
				<GridRowItemLabel>Legal Name</GridRowItemLabel>
				<GridRowItemDetails>{legalNameElem}</GridRowItemDetails>
				<GridRowItem>{legalNameActionElem}</GridRowItem>
			</GridRow>
			<GridRow>
				<GridRowItemLabel>Address</GridRowItemLabel>
				<GridRowItemDetails>
					<Box sx={{ alignItems: "flex-end", display: "flex", flexDirection: "column-reverse" }}>
						<React.Fragment>{legalAddressInvalidElem}</React.Fragment>
						<Box sx={{ pl: 1 }}>{legalAddressElem}</Box>
					</Box>
				</GridRowItemDetails>
				<GridRowItem>{legalAddressActionElem}</GridRowItem>
			</GridRow>
			<GridRow>
				<GridRowItemLabel>Contact Email</GridRowItemLabel>
				<GridRowItemDetails>
					<React.Fragment>{contactEmailInvalidElem}</React.Fragment>
					<Box sx={{ pl: 1 }}>{contactEmailElem}</Box>
				</GridRowItemDetails>
				<GridRowItem>{contactEmailActionElem}</GridRowItem>
				<GridRowItemLabel>Sign In Email</GridRowItemLabel>
				<GridRowItemDetails>
					<Box sx={{ pl: 1 }}>{iamEmailElem}</Box>
				</GridRowItemDetails>
				<GridRowItem>{iamEmailActionElem}</GridRowItem>
			</GridRow>
			<GridRow>
				<GridRowItemLabel>Contact Phone</GridRowItemLabel>
				<GridRowItemDetails>
					<React.Fragment>{primaryPhoneInvalidElem}</React.Fragment>
					<Box sx={{ pl: 1 }}>{primaryPhoneElem}</Box>
				</GridRowItemDetails>
				<GridRowItem>{primaryPhoneActionElem}</GridRowItem>
				<GridRowItemLabel>Sign In Phone</GridRowItemLabel>
				<GridRowItemDetails>
					<Box sx={{ pl: 1 }}>{iamPhoneElem}</Box>
				</GridRowItemDetails>
				<GridRowItem>{iamPhoneActionElem}</GridRowItem>
			</GridRow>
		</React.Fragment>
	);
};

const mapStateToProps = state => ({
	profileData: state.profile.data
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ContactInfoList);